const supabaseConf = {
  supabaseUrl: "https://ximbdwyekfmioxxeklhx.supabase.co",
  supabaseKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhpbWJkd3lla2ZtaW94eGVrbGh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzM0OTU5NjUsImV4cCI6MTk4OTA3MTk2NX0.RyaZGpVr62tD25Sd31ClEKnIt4VNC448pmaS6W9gOM0"
};

export default supabaseConf;
